import { resolveClient } from './supabase';
import type { Fund } from '@lingaai/types';
import type { SupabaseClient } from '@supabase/supabase-js';

export async function getFunds(tenantId?: string, client?: SupabaseClient): Promise<Fund[]> {
  const supabase = resolveClient(client);

  let query = supabase.from('funds').select('*').order('fund_number', { ascending: true, nullsFirst: false }).order('created_at', { ascending: false });

  if (tenantId) {
    query = query.eq('tenant_id', tenantId);
  }

  const { data, error } = await query;

  if (error) throw error;
  return data as Fund[];
}

export async function getFund(fundId: string, client?: SupabaseClient): Promise<Fund> {
  const supabase = resolveClient(client);

  const { data, error } = await supabase.from('funds').select('*').eq('id', fundId).single();

  if (error) throw error;
  return data as Fund;
}

export async function createFund(
  data: {
    tenant_id: string;
    name: string;
    external_id?: string | null;
    reporting_frequency?: 'monthly' | 'quarterly' | 'annual' | null;
  },
  client?: SupabaseClient
): Promise<Fund> {
  const supabase = resolveClient(client);

  const { data: fund, error } = await supabase.from('funds').insert(data).select().single();

  if (error) throw error;
  return fund as Fund;
}

export async function updateFund(fundId: string, updates: Partial<Fund>, client?: SupabaseClient): Promise<Fund> {
  const supabase = resolveClient(client);

  const { data, error } = await supabase.from('funds').update(updates).eq('id', fundId).select().single();

  if (error) throw error;
  return data as Fund;
}
